<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>配信テンプレート一覧</strong>
          </CCardHeader>
          <CCardBody>
            <CButton
              color="success"
              class="px-4"
              v-on:click="createTemplateCategory()"
            >
              <i class="icon cil-plus"></i>
              作成
            </CButton>

            <CDataTable
              class="my-3 table-outline bg-white"
              hover
              :items="tableItems"
              :fields="tableFields"
              column-filter
              sorter
              :items-per-page="10"
              size="sm"
              pagination
            >
              <td slot="category" class="text-left" slot-scope="{ item }">
                <strong>{{ item.category }}</strong>
              </td>
              <td slot="countMember" slot-scope="{ item }">
                <strong>{{ item.countMember }}</strong>
              </td>
              <td slot="countTemplate" class="text-left" slot-scope="{ item }">
                <strong>{{ item.countTemplate }}</strong>
              </td>
              <template #category_update="{ item }">
                <td class="py-2 text-center">
                  <CButton
                    size="sm"
                    class="px-3"
                    color="info"
                    v-on:click="editTemplateCategory(item.category)"
                    >編集</CButton
                  >
                </td>
              </template>
            </CDataTable>
            <CModal
              color="info"
              :closeOnBackdrop="false"
              size="lg"
              :show.sync="crudCategoryModal"
            >
              <div class="category_create_body">
                <CForm class="member-info">
                  <CRow>
                    <CCol>
                      <CInput
                        label="カテゴリー名"
                        horizontal
                        :options="options"
                        placeholder="名を入力してください。"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <CTextarea
                        label="内容"
                        horizontal
                        placeholder="内容を入力してください。"
                      />
                    </CCol>
                  </CRow>
                </CForm>
              </div>
              <template #header>カテゴリー{{ crudModalTitle }}</template>
              <template #footer>
                <CButton @click="crudCategoryModal = false" color="secondary"
                  >キャンセル</CButton
                >
                <CButton @click="createCategoryTemplate()" color="success">
                  <i class="icon cil-save"></i> 作成
                </CButton>
              </template>
            </CModal>
          </CCardBody>
          <CCardFooter> </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <!-- start_completeModal -->
  </div>
</template>

<script>
export default {
  name: "配信テンプレート",
  data() {
    return {
      crudCategoryModal: false,
      crudModalTitle: "",
      tableItems: [
        {
          category: "event",
          countMember: "11",
          countTemplate: "21",
          subject: "New Year coupon event",
        },
        {
          category: "renovation",
          countMember: "15",
          countTemplate: "4",
          subject: "Update room facility",
        },
      ],
      tableFields: [
        { key: "category", label: "カテゴリー名", _classes: "text-left bg-light", _style: "width:60%" },
        { key: "countMember", label: "総会員", _classes: "text-left bg-light" },
        {
          key: "countTemplate",
          label: "総テンプレート",
          _classes: "text-left bg-light",
        },
        {
          key: "category_update",
          _classes: " bg-light",
          label: "",
          _style: "width:10%",
          sorter: false,
          filter: false,
        },
      ],
    };
  },
  //入力項目にvalidation
  validations: {},
  beforeMount() {},
  methods: {
    createTemplateCategory() {
      this.crudCategoryModal = true;
      this.crudModalTitle = "作成";
    },
    editTemplateCategory(categoryItem) {
      this.crudCategoryModal = true;
      this.crudModalTitle = "編集";
      console.log(categoryItem);
    },
  },
};
</script>
